// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"29145a54","743":"a20c7455","787":"67f9bc60"}[chunkId] + ".chunk.js";
};